// extracted by mini-css-extract-plugin
export var legendIndicator = "_aq-1";
export var legendRight = "_aq-0";